import { ExtendableImage } from '@design-system/extendable-image';
import { ImageBlock as CSImageBlock } from '@design-system/image-block';
import React, { forwardRef } from 'react';

import { ImageBlockProps } from './models';

const ImageBlock = forwardRef<HTMLDivElement, ImageBlockProps>(
  ({ caption, images }, ref) => (
    <CSImageBlock caption={caption} ref={ref}>
      {images.map((image, i) => (
        // TODO: find better key - asset_id? but what if images be duplicated?...
        // eslint-disable-next-line react/no-array-index-key
        <ExtendableImage key={i} {...image} />
      ))}
    </CSImageBlock>
  )
);

export default ImageBlock;
